var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.pageType !== 'video')?_c('img',{attrs:{"src":_vm.source,"alt":_vm.alt}}):_c('video',{attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.source,"type":_vm.fileType}})])])}
var staticRenderFns = []

export { render, staticRenderFns }